<!-- ModuleCards.vue - Complete Redesign -->
<template>
  <div class="glass-module">
    <!-- Search Bar -->
    <!-- <div class="search-container">
      <div class="search-wrapper">
        <i class="fas fa-search search-icon"></i>
        <input 
          type="text" 
          v-model="localSearchQuery"
          placeholder="Search modules..." 
          class="search-input"
        />
        <button v-if="localSearchQuery" class="search-clear" @click="clearSearch">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div> -->

    <!-- Modules Grid -->
    <div class="modules-grid">
      <!-- SALES -->
      <div class="module-card modern-card" @click="$router.push('/sales/main/')"
           v-if="showModule(['admin', 'accountmanager', 'officeuser', 'officemanager', 'locationadmin', 'salesperson', 'accountuser']) && matchesSearch('SALES')">
        <div class="card-gradient sales-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-chart-line"></i> 
          </div>
          <div class="card-info">
            <h3>SALES</h3>
            <p>Sales management and tracking</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- PROCESS SALES -->
      <div class="module-card modern-card" @click="$router.push('/admin_tools/main/')"
           v-if="showModule(['admin', 'accountmanager', 'officeuser', 'officemanager', 'salesperson', 'accountuser']) && matchesSearch('PROCESS SALES')">
        <div class="card-gradient process-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-cogs"></i>
          </div>
          <div class="card-info">
            <h3>PROCESS SALES</h3>
            <p>System administration and tools</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- PROCESS DELIVERIES -->
      <div class="module-card modern-card" @click="$router.push('/incoming_outgoing/main/')"
           v-if="showModule(['admin', 'accountmanager', 'officeuser', 'officemanager', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'housetruck', 'deliverytruck']) && matchesSearch('PROCESS DELIVERIES')">
        <div class="card-gradient shipping-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-shipping-fast"></i>
          </div>
          <div class="card-info">
            <h3>PROCESS DELIVERIES</h3>
            <p>Manage incoming and outgoing shipments</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- RECEIVING -->
      <div class="module-card modern-card" @click="$router.push('/receiving/main/')"
           v-if="showModule(['admin', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'warehouseuser', 'warehousemanager']) && matchesSearch('RECEIVING')">
        <div class="card-gradient receiving-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-inbox"></i>
          </div>
          <div class="card-info">
            <h3>RECEIVING</h3>
            <p>Receiving logs and inventory movement</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- SHIPPING -->
      <div class="module-card modern-card" @click="$router.push('/shipping/main/')"
           v-if="showModule(['admin', 'warehousemanager', 'warehouseuser', 'deliverytruck', 'locationadmin']) && matchesSearch('SHIPPING')">
        <div class="card-gradient shipping-blue-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-box"></i>
          </div>
          <div class="card-info">
            <h3>SHIPPING</h3>
            <p>Shipping management and tracking</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- STORE STOCK TRANSFER -->
      <div class="module-card modern-card" @click="$router.push('/transfer_orders/main/')"
           v-if="showModule(['admin', 'officemanager', 'locationadmin', 'housetruck', 'warehousemanager']) && matchesSearch('STORE STOCK TRANSFER')">
        <div class="card-gradient transfer-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-exchange-alt"></i>
          </div>
          <div class="card-info">
            <h3>STORE STOCK TRANSFER</h3>
            <p>Inventory transfer between locations</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- VENDOR ORDERS -->
      <div class="module-card modern-card" @click="$router.push('/vendor_orders/main/')"
           v-if="showModule(['admin', 'accountmanager', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'accountuser']) && matchesSearch('VENDOR ORDERS')">
        <div class="card-gradient vendor-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-truck-loading"></i>
          </div>
          <div class="card-info">
            <h3>VENDOR ORDERS</h3>
            <p>Vendor and purchase order management</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- PRODUCTS -->
      <div class="module-card modern-card" @click="$router.push('/products/main/')"
           v-if="showModule(['admin', 'accountmanager', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'accountuser']) && matchesSearch('PRODUCTS')">
        <div class="card-gradient products-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-cube"></i>
          </div>
          <div class="card-info">
            <h3>PRODUCTS</h3>
            <p>Product catalog and info management</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- INVENTORY -->
      <div class="module-card modern-card" @click="$router.push('/inventory/main/')"
           v-if="showModule(['admin', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'accountuser']) && matchesSearch('INVENTORY')">
        <div class="card-gradient inventory-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-boxes"></i>
          </div>
          <div class="card-info">
            <h3>INVENTORY</h3>
            <p>Inventory management and stock control</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- REPORTS -->
      <div class="module-card modern-card" @click="$router.push('/reports/main/')"
           v-if="showModule(['admin', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'accountuser']) && matchesSearch('REPORTS')">
        <div class="card-gradient reports-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-chart-pie"></i>
          </div>
          <div class="card-info">
            <h3>SALES REPORTS</h3>
            <p>Business intelligence and reporting</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <div class="module-card modern-card" @click="$router.push('/product-reports/main/')"
     v-if="showModule(['admin', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'accountuser']) && matchesSearch('PRODUCT PERFORMANCE')">
  <div class="card-gradient performance-gradient"></div>
  <div class="card-content">
    <div class="card-icon-wrapper">
      <i class="fas fa-chart-bar"></i>
    </div>
    <div class="card-info">
      <h3>PRODUCT PERFORMANCE</h3>
      <p>Product analytics and performance metrics</p>
    </div>
    <button class="card-action-btn">
      <i class="fas fa-arrow-right"></i>
    </button>
  </div>
</div>

      <!-- CUSTOMER SERVICE -->
      <div class="module-card modern-card" @click="$router.push('/customer_service/main/')"
           v-if="showModule(['admin', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'accountuser']) && matchesSearch('CUSTOMER SERVICE')">
        <div class="card-gradient customer-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-headset"></i>
          </div>
          <div class="card-info">
            <h3>CUSTOMER SERVICE</h3>
            <p>Customer support and service management</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- DELIVERIES & TRIPS -->
      <div class="module-card modern-card" @click="$router.push('/DeliveryCalendar/main/')"
           v-if="showModule(['admin', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'accountuser']) && matchesSearch('DELIVERIES & TRIPS')">
        <div class="card-gradient delivery-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-truck"></i>
          </div>
          <div class="card-info">
            <h3>DELIVERIES & TRIPS</h3>
            <p>Delivery calendar and delivery management</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- CUSTOMERS -->
      <div class="module-card modern-card" @click="$router.push('/customers/main/')"
           v-if="showModule(['admin', 'accountmanager', 'officeuser', 'officemanager', 'locationadmin', 'salesperson', 'accountuser']) && matchesSearch('CUSTOMERS')">
        <div class="card-gradient customers-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-users"></i>
          </div>
          <div class="card-info">
            <h3>CUSTOMERS</h3>
            <p>Customer information and order management</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- ADMIN TOOLS -->
      <div class="module-card modern-card" @click="showAdminToolsModal = true"
           v-if="showModule(['admin', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'accountuser']) && matchesSearch('ADMIN TOOLS')">
        <div class="card-gradient admin-gradient"></div>
        <div class="card-content">
          <div class="card-icon-wrapper">
            <i class="fas fa-cog"></i>
          </div>
          <div class="card-info">
            <h3>ADMIN TOOLS</h3>
            <p>System configuration and user management</p>
          </div>
          <button class="card-action-btn">
            <i class="fas fa-external-link-alt"></i>
          </button>
        </div>
      </div>

      <!-- Empty State -->
      <div class="empty-modules" v-if="hasNoVisibleModules">
        <div class="empty-icon">
          <i class="fas fa-inbox"></i>
        </div>
        <h3>No modules available</h3>
        <p>There are no modules available for your current role or matching your search criteria.</p>
      </div>
    </div>

    <!-- ADMIN TOOLS MODAL -->
    <b-modal v-model="showAdminToolsModal"
             title="Admin Tools"
             size="lg"
             hide-footer
             centered
             class="admin-tools-modal-modern"
             header-class="modal-header-modern"
             body-class="modal-body-modern">

      <div class="admin-tools-modern-grid">
        <!-- LOCATIONS -->
        <div class="tool-card" @click="navigateTo('/locations/main/')"
             v-if="showModule(['admin'])">
          <div class="tool-icon locations-icon">
            <i class="fas fa-map-marker-alt"></i>
          </div>
          <div class="tool-info">
            <h4>LOCATIONS</h4>
            <p>Location and branch management</p>
          </div>
          <i class="fas fa-chevron-right tool-arrow"></i>
        </div>

        <!-- CONTROL PANEL -->
        <div class="tool-card" @click="navigateTo('/control_panel/main/')"
             v-if="showModule(['admin'])">
          <div class="tool-icon control-icon">
            <i class="fas fa-sliders-h"></i>
          </div>
          <div class="tool-info">
            <h4>CONTROL PANEL</h4>
            <p>System configuration and settings</p>
          </div>
          <i class="fas fa-chevron-right tool-arrow"></i>
        </div>

        <!-- USERS -->
        <div class="tool-card" @click="navigateTo('/users/main/')"
             v-if="showModule(['admin'])">
          <div class="tool-icon users-icon">
            <i class="fas fa-users"></i>
          </div>
          <div class="tool-info">
            <h4>USERS</h4>
            <p>User account and permission management</p>
          </div>
          <i class="fas fa-chevron-right tool-arrow"></i>
        </div>
      </div>

      <div class="modal-footer-actions">
        <b-button variant="secondary" @click="showAdminToolsModal = false">
          Close
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ModuleCards",
  props: {
    userDetails: {
      type: Object,
      default: () => ({})
    },
    searchQuery: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showAdminToolsModal: false,
      localSearchQuery: ""
    }
  },
  watch: {
    searchQuery: {
      immediate: true,
      handler(val) {
        this.localSearchQuery = val;
      }
    },
    localSearchQuery(val) {
      this.$emit('update:searchQuery', val);
    }
  },
  computed: {
    hasNoVisibleModules() {
      const modules = [
        { condition: this.showModule(['admin', 'accountmanager', 'officeuser', 'officemanager', 'locationadmin', 'salesperson', 'accountuser']), search: 'SALES' },
        { condition: this.showModule(['admin', 'accountmanager', 'officeuser', 'officemanager', 'locationadmin', 'salesperson', 'accountuser']), search: 'PROCESS SALES' },
        { condition: this.showModule(['admin', 'accountmanager', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'housetruck', 'deliverytruck']), search: 'PROCESS DELIVERIES' },
        { condition: this.showModule(['admin', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'warehouseuser', 'warehousemanager']), search: 'RECEIVING' },
        { condition: this.showModule(['admin', 'warehousemanager', 'warehouseuser', 'deliverytruck', 'locationadmin']), search: 'SHIPPING' },
        { condition: this.showModule(['admin', 'officemanager', 'locationadmin', 'housetruck', 'warehousemanager']), search: 'STORE STOCK TRANSFER' },
        { condition: this.showModule(['admin', 'accountmanager', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'accountuser']), search: 'VENDOR ORDERS' },
        { condition: this.showModule(['admin', 'accountmanager', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'accountuser']), search: 'PRODUCTS' },
        { condition: this.showModule(['admin', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'accountuser']), search: 'INVENTORY' },
        { condition: this.showModule(['admin', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'accountuser']), search: 'REPORTS' },
        { condition: this.showModule(['admin', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'accountuser']), search: 'PRODUCT PERFORMANCE' },
        { condition: this.showModule(['admin', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'accountuser']), search: 'CUSTOMER SERVICE' },
        { condition: this.showModule(['admin', 'officeuser', 'officemanager', 'locationadmin', 'locationstockperson', 'salesperson', 'warehouseuser', 'warehousemanager', 'accountuser']), search: 'DELIVERIES & TRIPS' },
        { condition: this.showModule(['admin', 'accountmanager', 'officeuser', 'officemanager', 'locationadmin', 'salesperson', 'accountuser']), search: 'CUSTOMERS' },
        
        { condition: this.showModule(['admin']), search: 'ADMIN TOOLS' }
      ];
      return !modules.some(module => module.condition && this.matchesSearch(module.search));
    }
  },
  methods: {
    showModule(roles) {
      return roles.includes(this.userDetails.userrole);
    },
    matchesSearch(moduleName) {
      if (!this.localSearchQuery) return true;
      return moduleName.toLowerCase().includes(this.localSearchQuery.toLowerCase());
    },
    clearSearch() {
      this.localSearchQuery = "";
    },
    navigateTo(route) {
      this.showAdminToolsModal = false;
      this.$router.push(route);
    }
  }
}
</script>

<style scoped>
.glass-module {
  background: transparent;
  border-radius: 24px;
}

/* Search Container */
.search-container {
  margin-bottom: 28px;
}

.search-wrapper {
  position: relative;
  max-width: 400px;
}

.search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 14px;
}

.search-input {
  width: 100%;
  padding: 12px 40px 12px 44px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 48px;
  font-size: 14px;
  transition: all 0.2s ease;
  backdrop-filter: blur(5px);
}

.search-input:focus {
  outline: none;
  border-color: #00698B;
  box-shadow: 0 0 0 3px rgba(0, 105, 139, 0.1);
  background: white;
}

.search-clear {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-clear:hover {
  color: #64748b;
  background: rgba(0, 0, 0, 0.05);
}

/* Modules Grid */
.modules-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}

/* Modern Card */
.modern-card {
  position: relative;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.modern-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 35px -12px rgba(0, 0, 0, 0.15);
  background: rgba(255, 255, 255, 0.85);
}

.card-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
}

.sales-gradient { background: linear-gradient(90deg, #10b981, #34d399); }
.process-gradient { background: linear-gradient(90deg, #f59e0b, #fbbf24); }
.shipping-gradient { background: linear-gradient(90deg, #ef4444, #f87171); }
.shipping-blue-gradient { background: linear-gradient(90deg, #3b82f6, #60a5fa); }
.receiving-gradient { background: linear-gradient(90deg, #8b5cf6, #a78bfa); }
.transfer-gradient { background: linear-gradient(90deg, #ec4899, #f472b6); }
.vendor-gradient { background: linear-gradient(90deg, #14b8a6, #2dd4bf); }
.products-gradient { background: linear-gradient(90deg, #f97316, #fb923c); }
.inventory-gradient { background: linear-gradient(90deg, #06b6d4, #22d3ee); }
.reports-gradient { background: linear-gradient(90deg, #6366f1, #818cf8); }
.customer-gradient { background: linear-gradient(90deg, #d946ef, #e879f9); }
.delivery-gradient { background: linear-gradient(90deg, #84cc16, #a3e635); }
.customers-gradient { background: linear-gradient(90deg, #0ea5e9, #38bdf8); }
.admin-gradient { background: linear-gradient(90deg, #6b7280, #9ca3af); }
.performance-gradient { background: linear-gradient(90deg, #00698B, #42a4e1); }

.card-content {
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.card-icon-wrapper {
  width: 52px;
  height: 52px;
  background: rgba(0, 105, 139, 0.1);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.modern-card:hover .card-icon-wrapper {
  background: #00698B;
}

.card-icon-wrapper i {
  font-size: 24px;
  color: #00698B;
  transition: all 0.2s ease;
}

.modern-card:hover .card-icon-wrapper i {
  color: white;
}

.card-info {
  flex: 1;
}

.card-info h3 {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
  letter-spacing: 0.3px;
}

.card-info p {
  font-size: 12px;
  color: #64748b;
  margin: 0;
  line-height: 1.4;
}

.card-action-btn {
  width: 36px;
  height: 36px;
  background: rgba(0, 105, 139, 0.08);
  border: none;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #00698B;
}

.modern-card:hover .card-action-btn {
  background: #00698B;
  color: white;
  transform: translateX(4px);
}

/* Empty State */
.empty-modules {
  grid-column: 1 / -1;
  text-align: center;
  padding: 60px 20px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 24px;
}

.empty-icon {
  font-size: 64px;
  color: #cbd5e0;
  margin-bottom: 20px;
}

.empty-modules h3 {
  font-size: 20px;
  color: #475569;
  margin-bottom: 8px;
}

.empty-modules p {
  color: #94a3b8;
  font-size: 14px;
}

/* Admin Tools Modal */
.admin-tools-modal-modern ::v-deep .modal-content {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  overflow: hidden;
  border: none;
}

.admin-tools-modal-modern ::v-deep .modal-header-modern {
  background: linear-gradient(135deg, #1e293b, #2d3748);
  color: white;
  border-bottom: none;
  padding: 20px 24px;
}

.admin-tools-modal-modern ::v-deep .modal-title {
  font-weight: 700;
  font-size: 18px;
}

.admin-tools-modal-modern ::v-deep .modal-body-modern {
  padding: 24px;
}

.admin-tools-modern-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tool-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.tool-card:hover {
  background: rgba(0, 105, 139, 0.05);
  transform: translateX(4px);
}

.tool-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tool-icon i {
  font-size: 22px;
  color: white;
}

.locations-icon { background: linear-gradient(135deg, #0ea5e9, #3b82f6); }
.control-icon { background: linear-gradient(135deg, #6b7280, #4b5563); }
.users-icon { background: linear-gradient(135deg, #10b981, #059669); }

.tool-info {
  flex: 1;
}

.tool-info h4 {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
}

.tool-info p {
  font-size: 12px;
  color: #64748b;
  margin: 0;
}

.tool-arrow {
  color: #cbd5e0;
  font-size: 14px;
  transition: all 0.2s ease;
}

.tool-card:hover .tool-arrow {
  color: #00698B;
  transform: translateX(4px);
}

.modal-footer-actions {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  text-align: center;
}

/* Responsive */
@media (max-width: 768px) {
  .modules-grid {
    grid-template-columns: 1fr;
  }
  
  .card-content {
    padding: 16px;
  }
  
  .card-icon-wrapper {
    width: 44px;
    height: 44px;
  }
  
  .card-icon-wrapper i {
    font-size: 20px;
  }
  
  .card-info h3 {
    font-size: 13px;
  }
  
  .card-info p {
    font-size: 11px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Homepagecomponents/ModuleCards.vue